import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { InputHTMLAttributes } from 'react'

const CheckboxInput = ({
  label,
  className,
  disabled,
  ...props
}: InputHTMLAttributes<HTMLInputElement> & {
  label: string
}) => (
  <label
    className={`flex items-center gap-4 text-text-primary ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'} ${className ?? ''}`}
  >
    <div className='relative flex'>
      <input
        type='checkbox'
        disabled={disabled}
        className='peer h-[30px] w-[30px] appearance-none rounded-md border-2 border-border-focus bg-surface-card text-status-success-on-strong transition-colors checked:border-status-success-strong checked:bg-status-success-strong focus-visible:outline focus-visible:outline-2 focus-visible:outline-border-focus focus-visible:outline-offset-2'
        {...props}
      />

      <FontAwesomeIcon
        icon='check'
        size='lg'
        className='pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-status-success-on-strong opacity-0 transition-opacity peer-checked:opacity-100'
      />
    </div>

    <span className='text-text-primary'>{label}</span>
  </label>
)

export default CheckboxInput
